import { alpha } from '@mui/material/styles';

export const cashbackSx = {
    pageCard: {
        border: theme => `1px solid ${theme.palette.divider}`,
        boxShadow: 'none',
        overflow: 'hidden',
    },
    filterSection: {
        px: 3,
        py: 2.5,
        bgcolor: theme => alpha(theme.palette.background.default, 0.6),
    },
    filterLabel: {
        fontWeight: 600,
        fontSize: '0.75rem',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        color: 'text.secondary',
        mb: 2,
    },
    tableHeadRow: {
        bgcolor: theme => alpha(theme.palette.primary.main, 0.04),
        '& th': {
            fontWeight: 600,
            fontSize: '0.8125rem',
            color: 'text.secondary',
            borderBottom: theme => `1px solid ${theme.palette.divider}`,
            whiteSpace: 'nowrap',
            py: 1.5,
        },
    },
    tableRow: {
        '&:last-child td': { borderBottom: 0 },
        transition: theme => theme.transitions.create('background-color'),
        '&:hover': {
            bgcolor: theme => alpha(theme.palette.action.hover, 0.5),
        },
    },
    amountText: {
        fontWeight: 600,
        fontVariantNumeric: 'tabular-nums',
    },
    emptyState: {
        py: 8,
    },
    modalSection: {
        p: 2,
        borderRadius: 1.5,
        border: theme => `1px solid ${theme.palette.divider}`,
        bgcolor: theme => alpha(theme.palette.background.default, 0.5),
    },
    modalSectionTitle: {
        fontWeight: 600,
        fontSize: '0.75rem',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        color: 'text.secondary',
        mb: 1.5,
    },
    modalAmountBox: {
        p: 2.5,
        borderRadius: 1.5,
        border: theme => `1px solid ${theme.palette.divider}`,
        bgcolor: theme => alpha(theme.palette.primary.main, 0.06),
    },
    fieldLabel: {
        display: 'block',
        fontWeight: 500,
        textTransform: 'uppercase',
        letterSpacing: '0.03em',
        fontSize: '0.6875rem',
        mb: 0.5,
    },
    paginationBar: {
        px: 3,
        py: 2,
        bgcolor: theme => alpha(theme.palette.background.default, 0.4),
    },
    modalPaper: {
        borderRadius: 2,
        overflow: 'hidden',
    },
    modalHeaderIcon: {
        p: 1,
        borderRadius: 1.5,
        bgcolor: theme => alpha(theme.palette.primary.main, 0.1),
        color: 'primary.main',
        display: 'flex',
    },
    modalTimeline: {
        p: 2,
        borderRadius: 1.5,
        border: theme => `1px solid ${theme.palette.divider}`,
        bgcolor: theme => alpha(theme.palette.background.default, 0.4),
    },
    modalTimelineIcon: {
        p: 0.75,
        borderRadius: 1,
        bgcolor: theme => alpha(theme.palette.primary.main, 0.08),
        color: 'primary.main',
        display: 'flex',
    },
};
